import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { all, call, takeLatest } from 'redux-saga/effects';
import { postReportUser } from '../api/repositories/reportUser/reportUser.sagas';
import { ActionsOfType } from '../helpers';
import { checkHasCompletedProfile } from '../helpers/checkSaga';
import { EReportUserActionType, TReportUserAction } from './actions';

export function* postReportUserSaga(
  action: ActionsOfType<TReportUserAction, EReportUserActionType.POST>
) {
  if (!(yield* checkHasCompletedProfile())) return;

  const { receiverId, reason } = action.payload;

  yield call(postReportUser, receiverId, reason);
}

export function* reportUserSaga() {
  yield all([
    takeLatest(
      EReportUserActionType.POST,
      handleAsyncStatus(postReportUserSaga, EAsyncEventTypes.POST_REPORT_USER)
    ),
  ]);
}
